/**
 * MSAL PublicClientApplication instance
 * Separated from main.jsx to avoid side effects during testing
 */
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig.js';

export const authInstance = new PublicClientApplication(msalConfig);

// Export a shared initialization promise so all callers can await a ready MSAL client.
export const msalInitializationPromise = authInstance.initialize();
